function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "allow_zero_value_cart": true,
    "transfer_label":"Transfer Cart",
    "graphql_token":"e85427d0df46c8593fa77f1d57b1a959",
    "custom_style":"body.punchout button.shopify-payment-button__button.shopify-payment-button__button--unbranded {display: none !important;} body.punchout .omg-button-quote-onboarding  { display:none; } #shopify-section-sections--16036804788286__header > sticky-header > header > nav > ul > li:nth-child(3) { display:none; } #shopify-section-sections--16036804788286__header > sticky-header > header > nav > ul > li:nth-child(4) { display:none; } #shopify-section-sections--16036804788286__header > sticky-header > header > div > a.header__icon.header__icon--account.link.focus-inset.small-hide { display:none; } #Share-template--16036804460606__main { display:none; } #shopify-section-sections--16036804755518__footer > footer > div.footer__content-top.page-width > div > div  { display:none; } #shopify-section-sections--16036804788286__header > sticky-header > header > div > div.button-view-history-quotes  display:none; } ",
    "checkout_selector":"button[name=\"checkout\"]",
    "transfer_selector":"button[name=\"transfer_items\"]",
    "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"cart__checkout-button button\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
    "return_selector": "header",
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>"
  };
   
    POExt = new Po2go_Shopify(store_config);     
    POSession = new Po2go({
        'account':'',
        'punchout_only' : store_config.punchout_only,
        'extension' : POExt
    });
    POSession.init();
    POSession.extension.setupPage();
    POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
}

